module.exports = __webpack_public_path__ + "img/Online payment Icon - charcoal.8826527d.svg";